import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table16 from "./components/Factors/Table/Table16";
import Table17 from "./components/Factors/Table/Table17";
import { useState } from "react";

const PageG6 = ({ reload }) => {
  const [halemasaleScore, setHalemasaleScore] = useState("")
  const [pasokhgooyiScore, setPasokhgooyiScore] = useState("")
  return (
    <>
      <Page pageNumber={30}>
        <HeaderFactors
          numberFactors="عامل دوازدهم"
          titelFactors="حل مساله و تصميم گيری"
          maxValue="40"
          jsValue={halemasaleScore}
        />
        <ExplainFactor
          text="این عامل بیانگر میزان نیاز شغل به حل مساله، تصمیم گیری و حل مشکلات است. مسائل ومشکالتی که
          شاغل با آن مواجه بوده و حل آن مستلزم انتخاب راهکاری مناسب و تصمیمات مقتضی است."
        />
        <Table16 halemasaleScore={halemasaleScore} setHalemasaleScore={setHalemasaleScore} reload={reload} />
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل سیزدهم"
          titelFactors="پاسخگویی"
          maxValue="40"
          jsValue={pasokhgooyiScore}
        />
        <ExplainFactor
          text="این عامل نتایج فعالیت ها، حجم و اندازه تاثیر تصمیمات و نتایج پیامدهای حاصل از تصمیم گیری در شغل را
          می سنجد ."
        />
        <Table17 pasokhgooyiScore={pasokhgooyiScore} setPasokhgooyiScore={setPasokhgooyiScore} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG6;
